<template>
    <div class="products">
        <b-container fluid v-for="(item, index) in subSeries" :key="index">
            <b-row v-for="(row, index) in item" :key="index">
                <b-col class="col" v-for="(col, index) in row" :key="index" cols="6">
                    <div class="banner" v-if="col.isBanner" :style="{backgroundImage: 'url('+ col.banner.imgSrc +')'}">
                        <!--<img :src="col.banner.imgSrc" alt="">-->
                        <div class="title">{{col.banner.title + ' '}} <span class="regular">{{col.banner.desc}}</span></div>
                        <div class="second-title">{{col.banner.secondTitle + ' '}} <span class="regular">{{col.banner.secondDesc}}</span></div>
                    </div>
                    <div v-else style="height: 100%">
                        <ScrollList class="product-list" :items="col.products" :cols="6" v-if="col.products.length > 0" @click="goToPage">
                            <template v-slot:default="{card}">
                                <b-card-text class="tag" v-if="card.tags.length > 0">
                                    {{card.tags[0].name}}
                                </b-card-text>
                                <b-card-text>
                                    <span class="title">{{card.title +' '}}</span>
                                    <span class="label">{{card.label}}</span>
                                </b-card-text>
                                <b-card-text v-for="(desc, descIndex) in card.desc" :key="descIndex">
                                <span class="desc">
                                    {{desc.text}}
                                </span>
                                </b-card-text>
                            </template>
                        </ScrollList>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import ScrollList from '../../common/ScrollList'

    export default {
        name: 'subSeries',
        props: {
            subSeries: Array,
            slug: String,
        },
        components: {
            ScrollList,
        },
        methods: {
            goToPage(slug) {
                this.$router.push({
                    path: '/product/' + slug
                })
                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../assets/style/var";

    .en {
        .col {
            .banner {
                .title {
                    font-family: Montserrat-Medium, Helvetica, Arial, sans-serif;
                    bottom: 97px !important;
                    letter-spacing: .03em;
                }

                .second-title {
                    bottom: 61px !important;
                    font-family: source-han-serif-sc, serif !important;
                }
            }
        }
    }

    .container-fluid {
        .product-list {
            overflow-x: hidden;
            height: 100%;
        }

        &:nth-child(n+2) {
            margin-top: 10px;
            .product-list {
                padding: 0;
            }
        }
    }

    .col {

        padding: 0;

        &:first-child {
            padding-right: 5px;
        }

        &:last-child {
            padding-left: 5px;
        }

        .banner {
            position: relative;
            width: 100%;
            height: 100%;
            padding-bottom: 64.1%;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center center;
            //cursor: pointer;
            transition: all .3s;

            /*&:hover {*/
                /*box-shadow:0px 3px 3px #c8c8c8 ;*/
            /*}*/

            > .title {
                position: absolute;
                bottom: 72px;
                display: block;
                width: 100%;
                padding: 0;
                font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                font-size: 24px;
                line-height: 36px;
                color: @primary-light-color;

                .regular {
                    font-weight: normal;
                }
            }

            > .second-title {
                position: absolute;
                bottom: 42px;
                display: block;
                width: 100%;
                padding: 0;
                font-size: 18px;
                line-height: 27px;
                color: @primary-light-color;

                .regular {
                    font-weight: normal;
                }
            }
        }

        img {
            width: 100%;
        }
    }

    .container {
        padding: 0 10px;
    }

    .col /deep/ .container {
        margin: 0;
    }

    .product-list {
        margin: 0;
        padding: 0;
    }

    .products {
        &:nth-child(n+3) {
            margin-top: 70px;
        }

        /deep/ .row {
            padding: 0;

            &:nth-child(n+2) {
                margin-top: 10px !important;
            }
        }

        /deep/ .list-item {
            padding: 0;

            .col {
                padding: 0;
                &:nth-child(1) {
                    padding-right: 5px;
                }

                &:nth-child(n + 2) {
                    padding-left: 5px;
                }
            }
        }

        /deep/ .container-fluid {
            .row {
                margin: 0;
            }
        }
    }
</style>
